// 这里主要是对host进行定义，
let localInterfaceHost;
//let a = 'development';
let a = 'online';
if (a === 'development') {
    localInterfaceHost = 'http://' + LOCATIONIP + ':3004/';
    console.log(localInterfaceHost);
}
const mockInterfaceHost = '';
const apiInterfaceHost = '';


let host_ip;
let host_sub_ip;
if (a === 'development') {
    host_ip = 'http://82.157.118.147:8080/flow/';
    host_sub_ip = 'http://82.157.118.147:8081/subflow/';
} else {
    // host_ip = 'http://82.157.127.92:8080/flow/';
    // host_sub_ip = 'http://82.157.127.92:8081/subflow/';
    //host_ip = 'https://service.adcube.com.cn/flow/';
    //host_sub_ip = 'https://service.adcube.com.cn/subflow/';
    host_ip = 'https://service.adxad.cn/flow/';
    host_sub_ip = 'https://service.adxad.cn/subflow/';
}

// host_ip = 'http://127.0.0.1:8080/flow/';
  // host_ip = 'http://172.30.28.10:8080/flow/';
  // host_ip = 'http://82.157.118.147:8080/flow/';
// host_sub_ip = 'http://127.0.0.1:8081/subflow/';

const DeviceIndexUrl = {
    list: host_sub_ip + 'deviceIndex/listRecord',
    detail: host_sub_ip + 'deviceIndex/detailRecord?',
    generate: host_sub_ip + 'deviceIndex/generateDeviceIndex',
    reGenerate: host_sub_ip + 'deviceIndex/reGenerateDeviceIndex',
    remove: host_sub_ip + 'deviceIndex/remove?devicePrefixName=',
    removeDeviceIndex: host_sub_ip + 'deviceIndex/removeDeviceIndex?devicePrefixName=',
    check: host_sub_ip + 'deviceIndex/checkDeviceIndex?devicePrefixName=',
    stop: host_sub_ip + 'deviceIndex/stopGenerateDeviceIndex?devicePrefixName=',
    listDeviceTags: host_sub_ip + 'deviceIndex/listDeviceTags?',
    listAreas: host_sub_ip + 'deviceIndex/listAreas?',
};


const LogCollectUrl = {
    list: host_ip + 'taskTrackLog/treeList',
    timeLineList: host_ip + 'taskTrackLog/timeLineList',
};


const TodayTask = {
    todyTaskData: host_ip + 'taskStatistic/startPage/execInfo',
    taskRealTimeMonitor: host_ip + 'service/taskMonitor',
    agentMonitor: host_ip + 'taskStatistic/getAgentInfo',
    serviceMonitor: host_ip + 'service/list',
    clearList: 'https://phone.adxad.cn/clearTaskQueue',
    clearOneList: 'https://phone.adxad.cn/clearTaskQueue?',
    // clearOneList: host_ip + 'service/test?',
    getIndexTaskList: host_ip + 'taskCheck/getIndexList',
};

const PartnerUrl = {
    list: host_ip + 'partner/list?',
    slist: host_ip + 'partner/slist?',
    modify: host_ip + 'partner/modify',
    delete: host_ip + 'partner/delete',
    selectById: host_ip + 'partner/selectById?_id=',
    paramList: host_ip + 'partner/paramList', // 地区以及合作商列表
    indexList: host_ip + 'partner/index',
    getProxyInfo: host_ip + 'taskStatistic/getProxyInfo?', // 代理商详情
    getProxyRepeatInfo: host_ip + 'taskStatistic/getProxyRepeatInfo?', // 代理商之间的重复信息
    getAgentProxyInfo: host_ip + 'taskStatistic/getAgentProxyInfo?',
    downloadProxyData: host_ip + 'taskStatistic/downloadProxyData',
};

const AgentConnectUrl = {

    getAgentConnInfo: host_ip + 'dataProvider/getPhoneConnNumNewData?',
    getNomalAgentConnInfo: host_ip + 'dataProvider/getNomalAgentConnInfo?',
    getAgentCurveData: host_ip + 'dataProvider/getProxyWidthAndConnectCurve?',
    getProxyWidthDetail: host_ip + 'dataProvider/getProxyWidthDetail?',
    getSortAgentWidthDetailData: host_ip + 'dataProvider/getSortAgentWidthDetailData',
getSizePieDataUrl: host_ip + 'dataProvider/getAgentBrandWidthSumAgent?',
};

const HostManageUrl = {
    list: host_ip + 'host/list',
    modify: host_ip + 'host/modify',
    delete: host_ip + 'host/delete',
    restart: host_ip + 'host/restart',
    add: host_ip + 'host/add',
    bulkChangeSatus: host_ip + 'host/deleteList',
    bulkUpdate: host_ip + 'host/bulkUpdate',
    addList: host_ip + 'host/addList',
    addWorkList: host_ip + 'outTenHost/addHour?',
    getServerInfo: host_ip + 'host/getServerConfig',
    getHttpServerInfo: host_ip + 'host/getHttpServerConfig',
    modifyServerConfig: host_ip + 'host/modifyServerConfig',
    restartWorkers: host_ip + 'host/restartWorkers',
    getAutoCutHostToday: host_ip + 'host/getAutoCutHostToday',
    getAutoAddHostTomorrow: host_ip + 'host/getAutoAddHostTomorrow',
    setAutoCutHostToday: host_ip + 'host/setAutoCutHostToday',
    setAutoAddHostTomorrow: host_ip + 'host/setAutoAddHostTomorrow',
    restartServer: host_ip + '/host/restartServer',
    againAllHostIndex: host_ip + '/host/againAllHostIndex',
};

const UserAngentsUrl = {
    list: host_ip + 'userAgent/list?',
    modify: host_ip + 'userAgent/modify',
    delete: host_ip + 'userAgent/delete',
    paramList: host_ip + 'userAgent/paramList',
    selectById: host_ip + 'userAgent/selectById?_id=',
};

const BrowserUrl = {
    list: host_ip + 'browser/list?',
    modify: host_ip + 'browser/modify',
    delete: host_ip + 'browser/delete',
    selectById: host_ip + 'browser/selectById?_id=',
};

const DeviceUrl = {
    list: host_ip + 'device/list?',
    modify: host_ip + 'device/modify',
    delete: host_ip + 'device/delete',
    selectById: host_ip + 'device/selectById?_id=',
};

const LocalResourceUrl = {
    list: host_ip + 'localResource/list?',
    modify: host_ip + 'localResource/modify',
    delete: host_ip + 'localResource/delete',
    selectById: host_ip + 'localResource/selectById?_id=',
    upload: host_ip + 'localResource/upload',
    deleteResouceByIds: host_ip + 'localResource/deleteResouceByIds',
};

const TecentConfigUrl = {
    list: host_ip + 'tecentConfig/list?',
    modify: host_ip + 'tecentConfig/modify',
    selectById: host_ip + 'tecentConfig/selectById?_id=',
};

const StandardLineUrl = {
    upload: host_ip + 'standardLine/upload',
    list: host_ip + 'standardLine/list?',
    deleteByCurveName: host_ip + 'standardLine/deleteByCurveName',
};

const AdvertPositionUrl = {
    insert: host_ip + 'phone/advertPosition/insert',
    list: host_ip + 'phone/advertPosition/list',
    modify: host_ip + 'phone/advertPosition/modify',
    delete: host_ip + 'phone/advertPosition/delete',
    selectById: host_ip + 'phone/advertPosition/selectById?_id=',
};

const AdvertPositionDataUrl = {
    list: host_ip + 'phone/adPositionData/list',
    modify: host_ip + 'phone/adPositionData/modify',
    curve: host_ip + 'phone/adPositionData/curve',
    exportUrl: host_ip + 'phone/adPositionData/export',
    // delete: host_ip + 'phone/adPositionData/delete',
    // selectById: host_ip + 'phone/adPositionData/selectById?_id=',
};

const OutTaskCategoryUrl = {
    list: host_ip + 'outTaskCategory/list?',
    modify: host_ip + 'outTaskCategory/modify',
    delete: host_ip + 'outTaskCategory/delete',
    selectById: host_ip + 'outTaskCategory/selectById?_id=',
    selectByName: host_ip + 'outTaskCategory/selectByName?name=',
};

const VPSUrl = {
    list: host_ip + 'vps/list?',
    modify: host_ip + 'vps/modify',
    delete: host_ip + 'vps/delete',
    selectById: host_ip + 'vps/selectById?_id=',
    bulkUpdateUrl: host_ip + 'vps/bulkModify',
};

const MonitorUrl = {
    service: host_ip + 'service/list?',
    localResourceRate: host_ip + 'service/getLocalResourceRate',
    vps: host_ip + 'vpsMonitor/list?',
    downHost: host_ip + 'vpsMonitor/exportDownVpsHost',
    operating: host_ip + 'operating/logs',
    phoneDetailData: host_ip + 'taskStatistic/phoneDetailData/getData', // 任务统计的表格数据
    proxyExecuteData: host_ip + 'dataProvider/getTaskProxyAgantList',
    proxyExecuteAreaData: host_ip + 'dataProvider/getTaskProxyAreaList',
    getDiscardTaskCountSuccess: host_ip + 'taskStatistic/getDiscardTaskCountSuccess',
    getDiscardTaskCountThreadHold: host_ip + 'taskStatistic/getDiscardTaskCountThreadHold',
    getTop5DiscardTaskCountSuccess: host_ip + 'taskStatistic/getTop5DiscardTaskCountSuccess',
    getTop5DiscardTaskCountThreadHold: host_ip + 'taskStatistic/getTop5DiscardTaskCountThreadHold',
    getAllProxyPoolLength: host_ip + 'task/getAllProxyPoolLength',
    delProxyKey: host_ip + 'task/delProxyKey',
    thirdParty: host_ip + 'monitoringcode/query',
    errorRate: host_ip + 'monitoringcode/errorRate',
    allDataSize: host_ip + 'monitoringcode/allDataSize',
    dataSize: host_ip + 'monitoringcode/dataSize',
    getErrorRateChart: host_ip + 'monitoringcode/getErrorRateChart',
    getDayTaskInfo: host_ip + 'taskStatistic/startPage/execInfoCount',
    getTaskDeviceInfo: host_ip + 'task/getDeviceInfoAndIpByDate',
    getDeviceInfoUrl: host_ip + 'task/getAllDeviceInfoPool',
    getBlockingTaskMonitor: host_ip + 'blockingTaskMonitor/query',
    checkPvGap: host_ip + 'monitoringcode/checkPvGap',
    getAppointProvince: host_ip + 'taskStatistic/startPage/getAppointProvince',
};

const TaskUrl = {
    list: host_ip + 'task/list',
    todayStartTask: host_ip + 'task/todayStartTask',
    downLoadTodayStartTask: host_ip + 'task/downLoadTodayStartTask',
    getTaskId: host_ip + 'task/getTaskId',
    submit: host_ip + 'task/modify',
    insert: host_ip + 'task/insert',
    opera: host_ip + 'task/delete',
    download: host_ip + 'task/exportTaskExcel',
    province: host_ip + 'task/provinceList',
    restTargetPv: host_ip + 'task/resetRedis',
    getTargetPv: host_ip + 'task/getPvFromRedis',
    cluster: host_ip + 'task/clusterList',
    outTaskCategory: host_ip + 'task/outTaskCategoryList',
    bulkUpdate: host_ip + 'task/bulkUpdate',
    bunchOnoffTask: host_ip + 'task/bunchOnOff',
    pasteSubTask: host_ip + 'task/setSubTasks',
    label: host_ip + 'task/labelList',
    curve: host_ip + 'task/getCurve',
    getApi: 'https://phone.adxad.cn/getDspUrl',
    getTasklogs: host_ip + 'operating/tasklogs',
    getTasklogByIndex: host_ip + 'operating/tasklogByIndex',
    getTaskNote: host_ip + 'notes/getNoteByEid',
    monitroList: host_ip + 'taskCheck/getMonitorNames',
    getAccountList: host_ip + 'account/getAllAccountList',
};

const TaskStatisticUrl = {
    list: host_ip + 'taskStatistic/list?', // 任务统计的表格数据
    total: host_ip + 'taskStatistic/total?', // 任务统计的图表数据
    taskInfos: host_ip + 'task/targetPvTotal?',
    exportTargetPvTotal: host_ip + 'task/exportTargetPvTotal?',
    sendMail10: host_ip + 'task/sendMail/10',
    sendMail18: host_ip + 'task/sendMail/18',
    report: host_ip + 'taskStatistic/report?', // 查询统计的数据
    exportReport: host_ip + 'taskStatistic/export/report?', // 数据导出
    exportData: host_ip + 'taskStatistic/exportExcel', // 小朱数据导出
    exportDataV2: host_ip + 'taskStatistic/exportExcelV2',
    everydayExecInfo: host_ip + 'taskStatistic/everyday/execInfo', // 执行情况
    importUrl: host_ip + 'task/importDol',
    exportEverydayExecTask: host_ip + 'taskStatistic/export/everyday/execTasks?',
};

const TaskExcutionUrl = {
    getListUrl: host_ip + 'taskExcution/getHZList',
    getAdListUrl: host_ip + 'taskExcution/getAdvertisementList',
    getStandarlineUrl: host_ip + 'taskExcution/getStandarline',
    getStandarlineTreeUrl: host_ip + 'taskExcution/getStandarlineTree',
};

const PartnerStatisticUrl = {
    list: host_ip + 'partnerStatistic/list?',
};

const UserUrl = {
    list: host_ip + 'user/list',
    allList: host_ip + 'user/allList',
    modify: host_ip + 'user/modify',
    modifySelf: host_ip + 'user/modifySelfPassword',
    del: host_ip + 'user/delete',
    add: host_ip + 'user/insert',
    getInfo: host_ip + 'user/selectByName',
    getUserGroups: host_ip + 'user/group/groups',
    addUserGroups: host_ip + 'user/group/insert',
    delUserGroups: host_ip + 'user/group/delete',
    editUserGroups: host_ip + 'user/group/modify',
    addMembers: host_ip + 'user/group/members',
    delMembers: host_ip + 'user/group/members',
    groups: host_ip + 'user/group/list',
    // "list": localInterfaceHost + "userlist",
    // "modify": localInterfaceHost + "usermodify"
};

const TaskMessage = {
    messageList: host_ip + 'taskMessage/list', // 消息列表
    viewed: host_ip + 'taskMessage/viewed', // 查阅消息
};

const LoginUrl = {
    login: host_ip + 'login',
    logout: host_ip + 'logout',
    validateCode: host_ip + '/validateCode?',
    getDuty: host_ip + '/check/getDuty',
};

const appAccountUrl = {
    accountList: host_ip + 'account/getAppAccountList', // 获取appCount列表
    addAccount: host_ip + 'account/addAppAccount',
    delAccount: host_ip + 'account/deleteAppAccount',
    setAccount: host_ip + 'account/modifyAccount',
    addAccountValues: host_ip + 'account/addAppAccountValue',
};

const wxAccountUrl = {
    accountList: host_ip + 'publicAcc/getWXAccountList',
    reget: host_ip + 'publicAcc/giveBackAccount',
    getCount: host_ip + 'publicAcc/getCounts',
};

const scriptUrl = {
    paramList: host_ip + 'script/paramList', // 消息列表
    getScriptList: host_ip + 'appScript/getScriptList', // 获取脚本列表appScript/getScriptList
    setScript: host_ip + 'appScript/setScript', // 编辑或删除脚本
    addScript: host_ip + 'appScript/addScript', // 添加脚本    /script/addScript
    del: host_ip + 'appScript/setScript', // 编辑或删除脚本
    delBatch: host_ip + 'appScript/delBatch', // 批量删除脚本
    getUserGroups: host_ip + 'appScript/getScriptList',
};

const certificateUrl = {
    paramList: host_ip + 'certificate/getCertificateEntityList',
    paramListQ: host_ip + 'certificate/getAppClientCrtEntityList',
    addCertificate: host_ip + 'certificate/addCertificate',
    updateCertificate: host_ip + 'certificate/setCertificate',
    delCertificate: host_ip + 'certificate/delCertificate',
    setCertificate: host_ip + 'certificate/setCertificate',
    resend: host_ip + 'certificate/sendCertificate',
};

const appManagerUrl = {
    appManagerList: host_ip + 'app/getAppManagerList',
    editManager: host_ip + 'app/modifyAppManager',
    delManager: host_ip + 'app/deleteAppManager',
    addManager: host_ip + 'app/addAppManager',
};

const clientUrl = {
    getcommandOrderList: host_ip + 'command/list', // 获取下发命令记录
    commendModify: host_ip + 'command/addCommand', // 重做
    getClientList: host_ip + 'client/getClientList', // 获取客户端
    restartClient: host_ip + 'command/addCommand', // 重启客户端
    setClient: host_ip + 'client/modifyClient', // 编辑客户端
    addCommand: host_ip + 'command/addCommand', // 下发命令
    getScriptList: host_ip + 'appScript/getScriptList', // 获取脚本列表
    setScript: host_ip + 'appScript/setScript', // 编辑或删除脚本
    addScript: host_ip + 'script/addScript', // 添加脚本
    deleteBatchAppClient: host_ip + 'client/deleteBatchAppClient', // 批量删除客户端
    updateBatchVersion: host_ip + 'client/updateBatchVersion',
    updateAllBatchVersion: host_ip + 'client/updateAllVersion',
    dellAllCommand: host_ip + 'command/delAllCommand',
    getAppv: host_ip + 'client/getAppv',
    updateAppList: host_ip + 'client/updateAllApp',
    updateBatchList: host_ip + 'client/updateBatchApp',
    getAllAppList: host_ip + 'app/getAllAppManagerList',
};

const machineCheck = {
    addMachine: host_ip + 'command/addMachineCheck', // 添加检查数据
    addCommandDb: host_ip + 'command/addCommandDb',
};

const fileUrl = {
    fileList: '//120.92.118.247/fileList.php',
    upload: '//120.92.118.247/upload',
    delete: '//120.92.118.247/delete.php',
    progress: '//120.92.118.247/progress',
};

const signUrl = {
    getEveryDayCheckInfo: host_ip + 'check/getEveryDayCheckInfo',
    update: host_ip + 'check/sginForToday',
    getCheckInfoList: host_ip + 'check/getCheckInfoList',
    getUserList: host_ip + 'check/getUserList',
};

const taskNotesUrl = {
    getTaskNotesList: host_ip + 'notes/list',
    delTaskNotes: host_ip + 'notes/del',
    editTaskNotes: host_ip + 'notes/edit',
    addTaskNotes: host_ip + 'notes/add',
    setOverflow: host_ip + 'task/setRandomOverflow',
};

const operationRecordsUrl = {
    getOperationRecordsList: host_ip + 'notes/listOperationRecord',
    delOperationRecords: host_ip + 'notes/delOperationRecord',
    editOperationRecords: host_ip + 'notes/updateOperationRecord',
    addOperationRecords: host_ip + 'notes/addOperationRecord',
    allMonitorNameUrl: host_ip + 'taskCheck/getMonitorNames',
};

const taskExcuteDataUrl = {
    getTaskExcuteDate: host_ip + 'taskCheck/getList',
    getMonitorNames: host_ip + 'taskCheck/getMonitorNames',
    getTaskExcuteEvDate: host_ip + 'taskCheck/getEVList',
};

const taskIvtDataUrl = {
    getTaskIvt: host_ip + 'taskCheck/getTaskAnalysis',
    getMonitorNames: host_ip + 'taskCheck/getMonitorNames',
};

const clientMangeUrl = {
    getGroupInfoList: host_ip + 'clientGroupInfo/getGroupInfoList',
    addGroupInfo: host_ip + 'clientGroupInfo/addGroupInfo',
    delBachGroupInfo: host_ip + 'clientGroupInfo/delBachGroupInfo',
    editGroupInfo: host_ip + 'clientGroupInfo/editGroupInfo',
    delGroupInfo: host_ip + 'clientGroupInfo/delGroupInfo',
};

export const APIHOST = localInterfaceHost;

export default {
    DeviceIndexUrl,
    LogCollectUrl,
    PartnerUrl,
    UserAngentsUrl,
    BrowserUrl,
    DeviceUrl,
    LocalResourceUrl,
    TecentConfigUrl,
    StandardLineUrl,
    OutTaskCategoryUrl,
    VPSUrl,
    MonitorUrl,
    TaskUrl,
    UserUrl,
    TaskStatisticUrl,
    TaskExcutionUrl,
    PartnerStatisticUrl,
    LoginUrl,
    TaskMessage,
    scriptUrl,
    TodayTask,
    HostManageUrl,
    clientUrl,
    certificateUrl,
    fileUrl,
    signUrl,
    clientMangeUrl,
    taskNotesUrl,
    machineCheck,
    taskExcuteDataUrl,
    taskIvtDataUrl,
    operationRecordsUrl,
    appManagerUrl,
    appAccountUrl,
    wxAccountUrl,
    AdvertPositionUrl,
    AdvertPositionDataUrl,
    AgentConnectUrl,
};



// WEBPACK FOOTER //
// ../config/index.js